import React, { useState, useEffect } from "react";
import { Input, Col, Row, Form, Checkbox, notification, Select, Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useMediaQuery } from 'react-responsive'
import RequestHandler from "../../util/RequestHandler";

const layout = {
  labelCol: {
    span: 10,
  },
  wrapperCol: {
    span: 11,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 8,
    span: 16,
  },
};

const TenantPaymentAccountAddForm = (props) => {
  const isDesktopOrLaptop = useMediaQuery({ query: '(min-device-width: 1224px)' });
  const isTabletOrMobileDevice = useMediaQuery({ query: '(max-device-width: 1224px)' });

  const [loading, setLoading] = useState(false);
  const [bankDropdown, setbankDropdown] = useState([]);
  const [bankBranchDropdown, setbankBranchDropdown] = useState([]);
  const [bankId, setbankId] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [iban, setIban] = useState("");

  const onChange = (value) => {
    RequestHandler.get(`/BankBranch/GetBranchForBank?id=${value}`).then(response => {
      setbankBranchDropdown(response);
      setbankId(value)
    });
  }
  const onChangeIban = (value) => {
    setIban(value.target.value);
  }
  const onChangeAccountNumber = (value) => {
    setAccountNumber(value.target.value);
  }

  useEffect(() => {
    RequestHandler.get(`/BankBranch/GetBranchForBank?id=${props.bankId}`).then(response => {
      setbankBranchDropdown(response);
    });

    RequestHandler.get(`/Bank`).then(response => {
      setbankDropdown(response.value.filter(x => x.isSupportAccountTransaction === true));
    });
  }, [setbankDropdown]);

  const openNotificationWithIcon = type => {
    notification[type]({
      message: 'BAŞARILI',
      description:
        'Ekleme işlemi başarı ile gerçekleşti.',
      duration: 2,
    });
  };

  const onFinish = values => {
    RequestHandler.post(`/TenantPaymentAccount`, {
      bankId: props.bankId,
      name: values.Name,
      iban: values.Iban,
      bankBranchId: values.BankBranchId,
      accountNumber: values.AccountNumber,
      isDefault: values.IsDefault === null ? false : values.IsDefault
    }, false, { rawResponse: true }).then(res => {
      if (res.status === 200) {
        openNotificationWithIcon('success');
        setTimeout(function () {
          window.location.reload();
        }.bind(this), 2000);
      }else{
        setLoading(false)
        }
    });
  };
  const onFinishFailed = () => setLoading(false);

  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(0, object.target.maxLength)
    }
  }

  const { Option } = Select;

  return (
    <div>
      <Form
        {...layout}
        name="basic"
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        fields={[
          { name: "BankId", value: props.bankId },
        ]}
      >
        <Row>
          {isDesktopOrLaptop && <>
            <Col span={24}>

              <Form.Item
                label="Hesap Adı"
                name="Name"
                onChange={onChangeAccountNumber}
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="Banka"
                name="BankId"
                rules={[
                  {
                    required: true,
                    message: 'Lütfen banka alanını boş bırakmayın.',
                  },
                ]}
              >
                <Select
                  showSearch
                  disabled
                  placeholder="Seçiniz."
                  optionFilterProp="children"
                  onChange={onChange}
                  filterOption={(input, option) =>
                    option.props.children
                      .toLocaleLowerCase("tr-TR")
                      .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                  }
                >
                  {bankDropdown.map(item => (
                    item.name === "KASA HESABI" ? "" :
                      <Option key={item.id} >{item.name}</Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="IBAN"
                name="Iban"
                onChange={onChangeIban}
                rules={
                  [
                    {
                      required: true,
                      message: 'Lütfen Iban alanını boş bırakmayın.',
                    },
                  ]}
              >
                <Input type="text" onKeyDown={(evt) => evt.keyCode === 32 && evt.preventDefault()} defaultValue="TR" onFocus={(event) => { event.target.select() }} maxLength="26" />
              </Form.Item>

              <Form.Item
                label="Banka Şubesi"
                name="BankBranchId"
             
              >
                <Select
                  showSearch
                  placeholder="Seçiniz"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.props.children
                      .toLocaleLowerCase("tr-TR")
                      .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                  }
                >
                  {bankBranchDropdown.map(item => (
                    <Option key={item.id} >{item.name}</Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="Hesap Numarası"
                name="AccountNumber"
                onChange={onChangeAccountNumber}
              >
                <Input maxLength="17" onInput={maxLengthCheck} />
              </Form.Item>


              <Form.Item
                label="Geçerli Hesap"
                name="IsDefault"
                valuePropName="checked"
              >
                <Checkbox />
              </Form.Item>

            </Col>

            <Col span={6}></Col>
            <Col span={6}></Col>
            <Col span={6}></Col>
            <Col span={3}>
              <Form.Item {...tailLayout} >
                <Button type="primary" icon={<PlusOutlined />} htmlType="submit" onClick={() => setLoading(true)} loading={loading}>
                  Ekle
                </Button>
              </Form.Item>
            </Col>
            <Col span={3}></Col>
          </>}
          {isTabletOrMobileDevice && <>
            <Col span={24}>
              <Form.Item
                label="Hesap Adı"
                name="Name"
                onChange={onChangeAccountNumber}
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="Banka"
                name="BankId"
                rules={[
                  {
                    required: true,
                    message: 'Lütfen banka alanını boş bırakmayın.',
                  },
                ]}
              >
                <Select
                  showSearch
                  disabled
                  placeholder="Seçiniz."
                  optionFilterProp="children"
                  onChange={onChange}
                  filterOption={(input, option) =>
                    option.props.children
                      .toLocaleLowerCase("tr-TR")
                      .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                  }
                >
                  {bankDropdown.map(item => (
                    item.name === "KASA HESABI" ? "" :
                      <Option key={item.id}>{item.name}</Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="IBAN"
                name="Iban"
                onChange={onChangeIban}
                rules={
                  [
                    {
                      required: true,
                      message: 'Lütfen Iban alanını boş bırakmayın.',
                    },
                  ]}
              >
                <Input type="text" defaultValue="TR" maxLength="26" />
              </Form.Item>

              <Form.Item
                label="Banka Şubesi"
                name="BankBranchId"
              >
                <Select
                  showSearch
                  placeholder="Seçiniz"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.props.children
                      .toLocaleLowerCase("tr-TR")
                      .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                  }
                >
                  {bankBranchDropdown.map(item => (
                    <Option key={item.id}>{item.name}</Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="Hesap Numarası"
                name="AccountNumber"
                onChange={onChangeAccountNumber}
              >
                <Input maxLength="17" onInput={maxLengthCheck} />
              </Form.Item>
              <Form.Item
                label="Geçerli Hesap"
                name="IsDefault"
                valuePropName="checked"
              >
                <Checkbox />
              </Form.Item>

            </Col>
            <Col span={12}></Col>

            <Col span={6}>
              <Form.Item {...tailLayout} >
                <Button type="primary" icon={<PlusOutlined />} htmlType="submit" onClick={() => setLoading(true)} loading={loading}>
                  Ekle
                </Button>
              </Form.Item>
            </Col>
            <Col span={6}></Col>
          </>}
        </Row>
      </Form>
    </div>
  )
}
export default TenantPaymentAccountAddForm